
import { TextField } from "@mui/material";
import { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../../../context/AppContext";
import { useFetch } from "../../../hooks/useFecth";
import HandlerApp from "../../../utils/handlerApp";
import { useForm } from "react-hook-form";
import BoldSelectValidated from "../../../utils/BoldSelectValidated";

const LocationsForms = () => {
    const endpoint = "administration/locations";
    const parent = "Company";
    const [t] = useTranslation("global");
    const [title, setTitle] = useState(t('locationComponent.createLocation'));
    const api = useFetch();
    const nav = useNavigate();
    const [data, setData] = useState([]);
    const handlerApp = HandlerApp();
    const { app } = useContext(AppContext);
    const { id } = useParams();

    const { register, handleSubmit, formState: { errors }, setValue } = useForm()
    
    // parametros
    const [locations, setlocations] = useState([]);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    // values
    const [country, setCountry] = useState("");
    const [state, setState] = useState("");
    const [city, setCity] = useState("");

    // formulario
    const [formData, setFormData] = useState({
        location_name: "",
        country_code: "",
        state_code: "",
        city_code: "",
        location_address: "",
        location_zipcode: "",
        language_id: "",
        currency_id: ""
    });

    // permisos
    const [permissions, setPermissions] = useState([]);
    const [menus, setMenus] = useState([]);
    
    useEffect(() => {
        setMenus(app.menus[parent]);
        setPermissions(app.permissions[endpoint])
    }, [app])

    useEffect(() => {
        handlerApp.setLoader(true);
        api.get(endpoint, {
            action: "getParamsUpdate"
        })
            .then(response => {
                if (response.success) {
                    setlocations(handlerApp.getResultFromObject(response.data, 'locations'))
                    setCountries(handlerApp.getResultFromObject(response.data,"countries"))
                    if (id !== undefined) {
                        setTitle(t('locationComponent.updateLocation'))
                        sendRequest();
                    } else {
                        handlerApp.setLoader(false);
                    }
                } else {
                    handlerApp.setLoader(false);
                }
            })
            .catch(error => {
                handlerApp.setLoader(false);
                handlerApp.showError(t(error.message));
            })
    }, [])

    // useEffect(()=>{
    //     handlerApp.setLoader(true);
    //     if(id !== undefined){
    //         setTitle(t('locationComponent.updateLocation'))
    //         sendRequest();
    //     }else{
    //         handlerApp.setLoader(false);
    //     }
    // },[])

    const handleDependencies = (data) => {
        setCountry(data.country_code);
        setState(data.state_code);
        let d = filterData(data, formData);
        setFormData(d);
    }

    const filterData = (data, formData) => {
        let finalData = {};
        for (let key in formData) {
            finalData[key] = data[key];
            setValue(key, data[key]);
        }
        return finalData;
    }

    const sendRequest = () => {
        api.get(endpoint + "/" + id,)
            .then(response => {
                if (response.success) {
                    let data = response.data[0];
                    handleDependencies(data);
                    handlerApp.setLoader(false);
                } else {
                    handlerApp.setLoader(false);
                }
            })
            .catch(error => {
                handlerApp.showError(t(error.message));
                handlerApp.setLoader(false);
            })
    }

    const handleForm = (e, name = null, dependency = null) => {
        let key = (name !== null) ? name : e.target.name;
        setFormData({
            ...formData,
            [key]: e.target.value
        });
        setValue(key, e.target.value);
        if (dependency !== null) {
            dependency(e.target.value);
        }
    }

    const handleCancel = (e) => {
        e.preventDefault();
        nav(-1);
    }

    // save data
    const handleSubmitForm = (data) => {
        handlerApp.setLoader(true);
        api.post(endpoint, data)
            .then(response => {
                if (response.success) {
                    handlerApp.showOk(response);
                    handlerApp.setLoader(false);
                    nav("/" + endpoint);
                } else {
                    handlerApp.handlerResponse(response);
                    handlerApp.setLoader(false);
                }

            })
            .catch(error => {
                handlerApp.showError(t(error.message));
                handlerApp.setLoader(false);
            })
    }

    const handleUpdateForm = (data) => {
        handlerApp.setLoader(true);
        api.put(endpoint + "/" + id, data)
            .then(response => {
                if (response.success) {
                    handlerApp.showOk(response);
                    handlerApp.setLoader(false);
                    nav("/" + endpoint);
                } else {
                    handlerApp.handlerResponse(response);
                    handlerApp.setLoader(false);
                }
            })
            .catch(error => {
                handlerApp.showError(t(error.message));
                handlerApp.setLoader(false);
            })
    }
    // dependencias
    // countries
    const handleSelectCountry = (val) => {
        if (val != null) {
            setCountry(val);
            setStates([]);
            setCities([]);
        }
    }
    // states
    const handleSelectState = (val) => {
        setState(val);
        setCities([]);
    }
    // cities
    const handleSelectCity = (val) => {
        setCity(val);
    }

    useEffect(() => {
        if (country != null) {
            getState();
        }
    }, [country])

    useEffect(() => {
        if (state != null) {
            getCities()
        }
    }, [state])

    const getState = () => {
        if (country !== undefined && country !== "") {
            handlerApp.setLoader(true);
            api.get(endpoint, {
                action: "getStates",
                country: country
            })
                .then(response => {
                    if (response.success) {
                        setStates(response.data);
                        handlerApp.setLoader(false);
                    } else {
                        handlerApp.setLoader(false);
                        handlerApp.handlerResponse(response);
                    }
                })
                .catch(error => {
                    handlerApp.showError(t(error.message));
                    handlerApp.setLoader(true);
                })
        }
    }

    const getCities = () => {
        if (state !== undefined && state !== "") {
            handlerApp.setLoader(true);
            api.get(endpoint, {
                action: "getCities",
                country: country,
                state: state
            })
                .then(response => {
                    if (response.success) {
                        setCities(response.data);
                        handlerApp.setLoader(false);
                    } else {
                        handlerApp.handlerResponse(response);
                        handlerApp.setLoader(false);
                    }
                })
                .catch(error => {
                    handlerApp.showError(t(error.message));
                    handlerApp.setLoader(false);
                })
        }
    }

    return (
        <div className="app container">
            <div className="title-section-forms">
                {title}
            </div>
            <div className="section-forms">
                <form onSubmit={handleSubmit((id === undefined) ? handleSubmitForm : handleUpdateForm)}>
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <TextField label={t("name")} variant="standard" size="small"
                                {...register("location_name", { required: true, maxLength: 40 })}
                                value={formData.location_name}
                                onChange={handleForm}
                                error={errors.location_name != null}
                                helperText={
                                    errors.location_name?.type === 'required' ? t("errors.required") :
                                        errors.location_name?.type === 'maxLength' ? t("errors.maxLength") : ""}
                            />
                        </div>
                        <div className="col-md-6 mb-2">
                            <BoldSelectValidated
                                title={t('country')}
                                value={formData.country_code}
                                name="country_code"
                                onChange={handleForm}
                                dependency={handleSelectCountry}
                                options={countries}
                                register={register}
                                errors={errors}
                                required={false}
                                variant="standard"
                            />
                        </div>
                        <div className="col-md-6 mb-2">
                            <BoldSelectValidated
                                title={t('state')}
                                value={formData.state_code}
                                name="state_code"
                                onChange={handleForm}
                                dependency={handleSelectState}
                                options={states}
                                register={register}
                                errors={errors}
                                required={false}
                                variant="standard"
                            />
                        </div>
                        <div className="col-md-6 mb-2">
                            <BoldSelectValidated
                                title={t('city')}
                                value={formData.city_code}
                                name="city_code"
                                onChange={handleForm}
                                dependency={handleSelectCity}
                                options={cities}
                                register={register}
                                errors={errors}
                                required={false}
                                variant="standard"
                            />
                        </div>
                        {/* <div className="col-md-6 mb-2">
                                <TextField label={t("locationComponent.currency")} variant="standard" size="small"
                                    {...register("currency_id",{ required: true, maxLength: 40})}
                                    value={formData.currency_id}
                                    onChange={handleForm}
                                    error={errors.currency_id!= null}
                                    helperText = {
                                        errors.currency_id?.type === 'required' ? t("errors.required") : 
                                        errors.currency_id?.type === 'maxLength' ? t("errors.maxLength") : ""}
                                />
                            </div>
                            <div className="col-md-6 mb-2">
                                <TextField label={t("locationComponent.language")} variant="standard" size="small"
                                    {...register("language_id",{ required: true, maxLength: 40})}
                                    value={formData.language_id}
                                    onChange={handleForm}
                                    error={errors.language_id!= null}
                                    helperText = {
                                        errors.language_id?.type === 'required' ? t("errors.required") : 
                                        errors.language_id?.type === 'maxLength' ? t("errors.maxLength") : ""}
                                />
                            </div>
                            <div className="col-md-6 mb-2">
                                <TextField label={t("country")} variant="standard" size="small"
                                    {...register("country_code",{ required: true, maxLength: 40})}
                                    value={formData.country_code}
                                    onChange={handleForm}
                                    error={errors.country_code!= null}
                                    helperText = {
                                        errors.country_code?.type === 'required' ? t("errors.required") : 
                                        errors.country_code?.type === 'maxLength' ? t("errors.maxLength") : ""}
                                />
                            </div>
                            <div className="col-md-6 mb-2">
                                <TextField label={t("state")} variant="standard" size="small"
                                    {...register("state_code",{ required: true, maxLength: 40})}
                                    value={formData.state_code}
                                    onChange={handleForm}
                                    error={errors.state_code!= null}
                                    helperText = {
                                        errors.state_code?.type === 'required' ? t("errors.required") : 
                                        errors.state_code?.type === 'maxLength' ? t("errors.maxLength") : ""}
                                />
                            </div>
                            
                             <div className="col-md-6 mb-2">
                                <TextField label={t("city")} variant="standard" size="small"
                                    {...register("city_code",{ required: false, maxLength: 120})}
                                    value={formData.city_code}
                                    onChange={handleForm}
                                    error={errors.city_code!= null}
                                    helperText = {
                                        errors.city_code?.type === 'required' ? t("errors.required") : 
                                        errors.city_code?.type === 'maxLength' ? t("errors.maxLength") : ""}
                                />
                            </div> */}
                        <div className="col-md-6 mb-2">
                            <TextField label={t("address")} variant="standard" size="small"
                                {...register("location_address", { required: false, maxLength: 120 })}
                                value={formData.location_address}
                                onChange={handleForm}
                                error={errors.location_address != null}
                                helperText={
                                    errors.location_address?.type === 'required' ? t("errors.required") :
                                        errors.location_address?.type === 'maxLength' ? t("errors.maxLength") : ""}
                            />
                        </div>
                        <div className="col-md-6 mb-2">
                            <TextField label={t("zipCode")} variant="standard" size="small"
                                {...register("location_zipcode", { required: false, maxLength: 8 })}
                                value={formData.location_zipcode}
                                onChange={handleForm}
                                error={errors.location_zipcode != null}
                                helperText={
                                    errors.location_zipcode?.type === 'required' ? t("errors.required") :
                                        errors.location_zipcode?.type === 'maxLength' ? t("errors.maxLength") : ""}
                            />
                        </div>

                        <div className="row d-flex justify-content-center">
                            <div className="col-md-3 d-flex justify-content-around">
                                <button className="bold-btn bold-btn-light" onClick={handleCancel} >{t('cancel')}</button>
                                {id === undefined && <button className="bold-btn bold-btn-dark" type="submit">{t('submit')}</button>}
                                {id && <button className="bold-btn bold-btn-dark" type="submit">{t('update')}</button>}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default LocationsForms;